import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ticket",
  "use": "icon-ticket-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-ticket\"><path fill-rule=\"evenodd\" d=\"M3.532 13.297c.54-.348.8-.836.668-1.478-.115-.558-.475-.922-1.033-1.044-.65-.142-1.145.12-1.493.65L0 9.739 9.762 0l1.682 1.683c-.558.363-.825.88-.646 1.559.144.542.518.88 1.074.977.63.11 1.102-.155 1.425-.655L15 5.26 5.237 15l-1.705-1.703\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol